

export default function GtagAccept(){


    // window.dataLayer = window.dataLayer || [];
    // function gtag(){window.dataLayer.push(arguments);}


    // gtag('consent', 'update', {
    //     'ad_user_data': 'granted',
    //     'ad_personalization': 'granted',
    //     'ad_storage': 'granted',
    //     'analytics_storage': 'granted'
    //   });

    let script = document.createElement('script');
    script.innerHTML = `
      if(typeof gtag != 'undefined'){
        
        gtag('consent', 'update', {
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
        'ad_storage': 'granted',
        'analytics_storage': 'granted'
      });

      gtag('event', 'page_view', {'page_title': document.title});

    }`

    document.head.appendChild(script);

}